import { routes } from '@/app/routing/router'
import { LastProgress } from './view'

const currentRoute = routes.lastProgress

const LastProgressRoute = {
  route: currentRoute,
  view: LastProgress,
}

export { currentRoute, LastProgressRoute }
